import { getInitials } from '@/helpers/strings'
import { Avatar } from '@mui/material'
import type { AvatarProps } from '@mui/material'

import { forwardRef } from 'react'

import { useParticipantColor } from './participant-palette'

type Props = { userId?: string | number | null; name: string } & AvatarProps

/**
 * Initials avatar for a team-order participant. Owns the colour-key convention (userId,
 * name as fallback) so the strip and the per-line attribution rows can never drift apart;
 * the colour itself is dealt out per basket by ParticipantPaletteProvider.
 * forwardRef + prop spread because MUI Tooltip clones its child with a ref and handlers.
 */
export const ParticipantAvatar = forwardRef<HTMLDivElement, Props>(function ParticipantAvatar(
  { userId, name, sx, ...avatarProps },
  ref,
) {
  const color = useParticipantColor(String(userId ?? name))

  return (
    <Avatar ref={ref} {...avatarProps} sx={{ bgcolor: color, ...sx }}>
      {getInitials(name)}
    </Avatar>
  )
})
